import { render } from "./Resumen.vue?vue&type=template&id=61d754de&scoped=true"
import script from "./Resumen.vue?vue&type=script&lang=js"
export * from "./Resumen.vue?vue&type=script&lang=js"

import "./Resumen.vue?vue&type=style&index=0&id=61d754de&scoped=true&lang=css"
import "./Resumen.vue?vue&type=style&index=1&id=61d754de&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d754de"]])

export default __exports__